import { Navigate, NavLink, useNavigate } from "react-router-dom";
import "./CondoAdmin.css";
import { toast } from "react-toastify";
import { jwtDecode } from "jwt-decode";

// export const ProtectedRoute = ({ children }) => {
//   const token = localStorage.getItem("superadmin_token");
//   if (!token) {
//     return <Navigate to="/superadmin" replace />;
//   }
//   return children;
// };

export const getCurrentUserRole = () => {
  const token = localStorage.getItem("admin_token");
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    return decoded.role;
  } catch (error) {
    console.error("Invalid token", error);
    return null;
  }
};

// export const SuperAdminProtectedRoute = ({ children }) => {
//   const superadminToken = localStorage.getItem("superadmin_token");
//   const adminToken = localStorage.getItem("admin_token");

//   // if admin is logged in, block superadmin access
//   if (adminToken || superadminToken) {
//     return <Navigate to="/condoDashboard" replace />;
//   }

//   if (!superadminToken) {
//     return <Navigate to="/superadmin" replace />;
//   }

//   return children;
// };

export const AdminOrSuperadminRoute = ({ children }) => {
  const token = localStorage.getItem("admin_token");
  const role = getCurrentUserRole();

  if (!token || (role !== "ADMIN" && role !== "SUPERADMIN")) {
    return <Navigate to="/adminLogin" replace />;
  }
  return children;
};

export const SuperAdminOnlyRoute = ({ children }) => {
  const role = getCurrentUserRole();
  if (role !== "SUPERADMIN") return <Navigate to="/unauthorized" />;
  return children;
};

export const ProtectedRoute = ({ children }) => {
  const adminToken = localStorage.getItem("admin_token");
  const superadminToken = localStorage.getItem("superadmin_token");

  // if superadmin is logged in, block admin access
  if (superadminToken) {
    return <Navigate to="/condoDashboard" replace />;
  }

  if (!adminToken) {
    return <Navigate to="/adminLogin" replace />;
  }

  return children;
};

// export const AdminOrSuperadminRoute = ({ children }) => {
//   const adminToken = localStorage.getItem("admin_token");
//   const superadminToken = localStorage.getItem("superadmin_token");

//   if (!adminToken && !superadminToken) {
//     return <Navigate to="/adminLogin" replace />;
//   }

//   return children;
// };

const CondoAdminNavbar = () => {
  const navigate = useNavigate();
  const isSuperAdmin = !!localStorage.getItem("superadmin_token");
  const isAdmin = !!localStorage.getItem("admin_token");

  // const handleLogout = () => {
  //   localStorage.removeItem("superadmin_token");
  //   navigate("/superadmin");
  // };
  // const handleLogout = () => {
  //   if (localStorage.getItem("superadmin_token")) {
  //     localStorage.removeItem("superadmin_token");
  //     navigate("/superadmin");
  //     toast.success("Logged out successfully");
  //   } else if (localStorage.getItem("admin_token")) {
  //     localStorage.removeItem("admin_token");
  //     navigate("/adminLogin");
  //     toast.success("Logged out successfully");
  //   } else {
  //     navigate("/superadmin");
  //   }
  // };
  const handleLogout = () => {
    localStorage.removeItem("admin_token");
    navigate("/adminLogin");
    toast.success("Logged out successfully");
  };
  const role = getCurrentUserRole();
  return (
    <div className="navbar-bg-condo navbar-bg inter-font-500">
      <nav className="navbar navbar-expand-lg ">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            <img
              src="	https://res.cloudinary.com/dbtsrjssc/image/upload/v1722329672/naffan_in_car_1_cote6w.png"
              alt="logo"
            />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav m-auto mb-2 mb-lg-0">
              {role === "SUPERADMIN" && (
                <NavLink className="nav-link" to="/condoAddAdmins">
                  Add Admins
                </NavLink>
              )}
              <li className="nav-item ">
                <NavLink className="nav-link" to="/condoDashboard">
                  Admin Dashboard
                </NavLink>
              </li>
              {/* <li className="nav-item">
                <NavLink className="nav-link" to="/admin/coin">
                  Coin
                </NavLink>
              </li> */}
              <li className="nav-item">
                <NavLink className="nav-link" to="/condoAdmin/news">
                  Admin News
                </NavLink>
              </li>{" "}
              <li className="nav-item">
                <NavLink className="nav-link" to="/condoAdmin/blogs">
                  Admin Blogs
                </NavLink>
              </li>
              {/* <li className="nav-item">
                <NavLink className="nav-link" to="/condoAdmin/airdrop">
                  Add Airdrop
                </NavLink>
              </li> */}
            </ul>
            <div className="btn btn-danger pl-2" onClick={handleLogout}>
              <i className="fa fa-sign-out" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default CondoAdminNavbar;
